export default __webpack_public_path__ + "static/media/softdrinks.6e9ab342.jpg";